<div
  *ngFor="let i of stepCount | mgRange"
  (click)="clickStepNode(i)"
  class="step-indicator-node"
  [class.mg-active]="activeStep == i"
  [class.mg-complete]="activeStep > i"></div>
